export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Surgical Instrumentation Educator — London, United Kingdom',
    'My students finally understand the difference between surgical instrument classification, aseptic techniques, perioperative workflow, and patient safety fundamentals. I used to waste hours searching for the right way to explain how surgical instrumentation actually works. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain instrument identification, sterilization protocols, operating room management, or how to teach professional reasoning in surgical contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Surgical Instrumentation and Operating Room Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated surgical instrumentation projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Surgical Instrumentation Educator | London, United Kingdom',
    "The material on instrument classification and aseptic techniques completely changed how my students understand surgical instrumentation. They finally grasp how sterilization protocols and teamwork prevent patient complications. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Technical Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Surgical Instrumentation Teacher | Berlin, Germany',
    "The 50 surgical instrumentation projects transformed how my students see real-world applications. Now they identify instruments, understand sterilization requirements, evaluate patient safety scenarios, and grasp why surgical instrumentation knowledge matters professionally and in real operating room environments. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The surgical instrumentation terminology handbook gave me back my class time. I used to spend time explaining surgical concepts and misconceptions. Now I show the handbook and students instantly understand surgical instrumentation concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Surgical Instrumentation Instructor | Copenhagen, Denmark',
    "The 100 case studies were eye-opening. My students finally understand why all this matters. They're analyzing real surgical instrumentation challenges, evaluating aseptic technique situations, exploring professional responsibility dilemmas, and understanding how technical reasoning contributes to patient safety and healthcare quality. This completely transformed how they see surgical instrumentation.",
  ],
];
